import { Directive, Input, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[defaultSrc]'
})
export class DefaultSrcDirective {

    @Input('defaultSrc') defaultSrc = '';
    @HostListener('error') onerror() {
        this.el.nativeElement.src = this.defaultSrc;
    }

    constructor(private el: ElementRef) {
    }

}
